import React from "react";
import LocalizedWeatherGuidePage from "@/components/weather/LocalizedWeatherGuidePage";

export default function AirPressureGuide() {
  return <LocalizedWeatherGuidePage guideKey="airPressure" />;
}